document.addEventListener('DOMContentLoaded', () => {
  const gallery = document.querySelector('media-gallery');
  if (!gallery) return;

  const viewer = document.createElement('div');
  viewer.className = 'mobile-image-viewer';

  viewer.innerHTML = `
    <button class="mobile-image-viewer__close" aria-label="Close image viewer">&times;</button>
    <div class="mobile-image-viewer__track"></div>
    <div class="mobile-image-viewer__counter"></div>
  `;

  document.body.appendChild(viewer);

  const track = viewer.querySelector('.mobile-image-viewer__track');
  const counter = viewer.querySelector('.mobile-image-viewer__counter');
  const closeButton = viewer.querySelector('.mobile-image-viewer__close');

  function getImages() {
    return Array.from(
      gallery.querySelectorAll('.product__media-item img')
    );
  }

  function updateCounter() {
    const slides = track.querySelectorAll('.mobile-image-viewer__slide');
    if (!slides.length) return;

    const index = Math.round(track.scrollLeft / track.clientWidth);

    counter.textContent =
      `${Math.min(index + 1, slides.length)} / ${slides.length}`;
  }

  function openViewer(clickedImage) {

    const images = getImages();
    const clickedIndex = images.indexOf(clickedImage);

    track.innerHTML = '';

    images.forEach((image) => {
      const slide = document.createElement('div');
      slide.className = 'mobile-image-viewer__slide';

      const fullImage = document.createElement('img');

      let imageSrc = image.currentSrc || image.src;

      if (imageSrc.includes('width=')) {
        imageSrc = imageSrc.replace(/width=\d+/, 'width=1600');
      }

      fullImage.src = imageSrc;
      fullImage.alt = image.alt || '';
      fullImage.draggable = false;

      slide.appendChild(fullImage);
      track.appendChild(slide);
    });

    viewer.classList.add('is-open');
    document.body.classList.add('mobile-viewer-open');

    requestAnimationFrame(() => {
      track.scrollLeft = Math.max(clickedIndex, 0) * track.clientWidth;
      updateCounter();
    });
  }

  function closeViewer() {
    viewer.classList.remove('is-open');
    document.body.classList.remove('mobile-viewer-open');
  }

  gallery.addEventListener(
    'click',
    (event) => {
      const image = event.target.closest('.product__media-item img');
      if (!image) return;

      event.preventDefault();
      event.stopPropagation();

      openViewer(image);
    },
    true
  );

  closeButton.addEventListener('click', closeViewer);

  track.addEventListener('scroll', updateCounter, {
    passive: true
  });
});